/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spoiler_HiddenInputs */

const th_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซ่อนอยู่`)
};

const en_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hidden`)
};

const ja_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非表示`)
};

const zh_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已隐藏`)
};

const es_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oculto`)
};

const pt_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oculto`)
};

const id_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`disembunyikan`)
};

const fr_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`masqué`)
};

const tl_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nakatago`)
};

const vi_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đã ẩn`)
};

const ko_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숨김`)
};

const de_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verborgen`)
};

const ru_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`скрыт`)
};

const tr_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gizli`)
};

const it_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nascosto`)
};

const pl_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ukryty`)
};

const uk_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`приховано`)
};

const hi_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छिपा`)
};

const ar_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخفية`)
};

const ms_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`disembunyikan`)
};

const bn_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লুকানো`)
};

const zh_tw2_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已隱藏`)
};

const zh_hk2_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已隱藏`)
};

const ur_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چھپا ہوا`)
};

const fa_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پنهان`)
};

const sw_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`imefichwa`)
};

const nl_spoiler_hidden = /** @type {(inputs: Spoiler_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verborgen`)
};

/**
* | output |
* | --- |
* | "hidden" |
*
* @param {Spoiler_HiddenInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const spoiler_hidden = /** @type {((inputs?: Spoiler_HiddenInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spoiler_HiddenInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_spoiler_hidden(inputs)
	if (locale === "ja") return ja_spoiler_hidden(inputs)
	if (locale === "zh") return zh_spoiler_hidden(inputs)
	if (locale === "es") return es_spoiler_hidden(inputs)
	if (locale === "pt") return pt_spoiler_hidden(inputs)
	if (locale === "id") return id_spoiler_hidden(inputs)
	if (locale === "fr") return fr_spoiler_hidden(inputs)
	if (locale === "tl") return tl_spoiler_hidden(inputs)
	if (locale === "vi") return vi_spoiler_hidden(inputs)
	if (locale === "ko") return ko_spoiler_hidden(inputs)
	if (locale === "de") return de_spoiler_hidden(inputs)
	if (locale === "ru") return ru_spoiler_hidden(inputs)
	if (locale === "tr") return tr_spoiler_hidden(inputs)
	if (locale === "it") return it_spoiler_hidden(inputs)
	if (locale === "pl") return pl_spoiler_hidden(inputs)
	if (locale === "uk") return uk_spoiler_hidden(inputs)
	if (locale === "hi") return hi_spoiler_hidden(inputs)
	if (locale === "ar") return ar_spoiler_hidden(inputs)
	if (locale === "ms") return ms_spoiler_hidden(inputs)
	if (locale === "bn") return bn_spoiler_hidden(inputs)
	if (locale === "zh-TW") return zh_tw2_spoiler_hidden(inputs)
	if (locale === "zh-HK") return zh_hk2_spoiler_hidden(inputs)
	if (locale === "ur") return ur_spoiler_hidden(inputs)
	if (locale === "fa") return fa_spoiler_hidden(inputs)
	if (locale === "sw") return sw_spoiler_hidden(inputs)
	if (locale === "nl") return nl_spoiler_hidden(inputs)
	return en_spoiler_hidden(inputs)
});